import { translate } from 'vue-gettext'

const { pgettext } = translate

const OrderStatus = {
    CREATED: {
        value: 1,
        label: pgettext('edge-orders.status', 'Created'),
        color: 'secondary'
    },
    PENDING_PAYMENT: {
        value: 2,
        label: pgettext('edge-orders.status', 'Pending Payment'),
        color: 'warning'
    },
    FAILED: {
        value: 3,
        label: pgettext('edge-orders.status', 'Failed'),
        color: 'danger'
    },
    CANCELED: {
        value: 4,
        label: pgettext('edge-orders.status', 'Canceled'),
        color: 'dark'
    },
    PROCESSING: {
        value: 5,
        label: pgettext('edge-orders.status', 'To Print'),
        color: 'warning'
    },
    COMPLETED: {
        value: 6,
        label: pgettext('edge-orders.status', 'Completed'),
        color: 'success'
    }
}

export default OrderStatus

export const getOrderStatusOptions = () => {
    return Object.values(OrderStatus).map(status => ({
        value: status.value,
        label: status.label
    }))
}

export const getOrderStatusByValue = (value) => {
    return Object.values(OrderStatus).find(s => s.value === value)
}

export const getOrderStatusLabel = (status) => {
    const statusObj = getOrderStatusByValue(status)
    return statusObj ? statusObj.label : status
}

export const getOrderStatusColor = (status) => {
    const statusObj = getOrderStatusByValue(status)
    return statusObj ? statusObj.color : 'secondary'
}